export { default as i18n } from '@guuru/translation-common';
export * from './src/translations';
